var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3571 0H9.64286C4.31725 0 0 4.31725 0 9.64286V35.3571C0 40.6827 4.31725 45 9.64286 45H35.3571C40.6827 45 45 40.6827 45 35.3571V9.64286C45 4.31725 40.6827 0 35.3571 0Z",
    fill: "url(#paint0_radial_3704_27539)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3571 0H9.64286C4.31725 0 0 4.31725 0 9.64286V35.3571C0 40.6827 4.31725 45 9.64286 45H35.3571C40.6827 45 45 40.6827 45 35.3571V9.64286C45 4.31725 40.6827 0 35.3571 0Z",
    fill: "url(#paint1_radial_3704_27539)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3571 0H9.64286C4.31725 0 0 4.31725 0 9.64286V35.3571C0 40.6827 4.31725 45 9.64286 45H35.3571C40.6827 45 45 40.6827 45 35.3571V9.64286C45 4.31725 40.6827 0 35.3571 0Z",
    fill: "url(#paint2_radial_3704_27539)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7501 13.6607C33.7501 14.9921 32.6708 16.0714 31.3394 16.0714C30.0081 16.0714 28.9287 14.9921 28.9287 13.6607C28.9287 12.3293 30.0081 11.25 31.3394 11.25C32.6708 11.25 33.7501 12.3293 33.7501 13.6607Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5001 30.5363C26.938 30.5363 30.5358 26.9385 30.5358 22.5006C30.5358 18.0626 26.938 14.4648 22.5001 14.4648C18.0621 14.4648 14.4644 18.0626 14.4644 22.5006C14.4644 26.9385 18.0621 30.5363 22.5001 30.5363ZM22.5001 27.322C25.1629 27.322 27.3215 25.1634 27.3215 22.5006C27.3215 19.8377 25.1629 17.6791 22.5001 17.6791C19.8372 17.6791 17.6786 19.8377 17.6786 22.5006C17.6786 25.1634 19.8372 27.322 22.5001 27.322Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42871 21.8563C6.42871 16.4558 6.42871 13.7555 7.47972 11.6928C8.40421 9.8784 9.87938 8.40323 11.6938 7.47874C13.7565 6.42773 16.4568 6.42773 21.8573 6.42773H23.143C28.5435 6.42773 31.2438 6.42773 33.3064 7.47874C35.1209 8.40323 36.5961 9.8784 37.5205 11.6928C38.5716 13.7555 38.5716 16.4558 38.5716 21.8563V23.142C38.5716 28.5425 38.5716 31.2428 37.5205 33.3054C36.5961 35.1199 35.1209 36.5951 33.3064 37.5195C31.2438 38.5706 28.5435 38.5706 23.143 38.5706H21.8573C16.4568 38.5706 13.7565 38.5706 11.6938 37.5195C9.87938 36.5951 8.40421 35.1199 7.47972 33.3054C6.42871 31.2428 6.42871 28.5425 6.42871 23.142V21.8563ZM21.8573 9.64202H23.143C25.8964 9.64202 27.7679 9.64453 29.2146 9.76272C30.6239 9.87785 31.3446 10.0865 31.8473 10.3427C33.0568 10.959 34.0402 11.9425 34.6566 13.152C34.9127 13.6547 35.1215 14.3754 35.2366 15.7847C35.3547 17.2314 35.3573 19.1029 35.3573 21.8563V23.142C35.3573 25.8954 35.3547 27.7669 35.2366 29.2136C35.1215 30.6229 34.9127 31.3436 34.6566 31.8463C34.0402 33.0558 33.0568 34.0392 31.8473 34.6556C31.3446 34.9118 30.6239 35.1205 29.2146 35.2356C27.7679 35.3537 25.8964 35.3563 23.143 35.3563H21.8573C19.1039 35.3563 17.2324 35.3537 15.7857 35.2356C14.3764 35.1205 13.6557 34.9118 13.153 34.6556C11.9434 34.0392 10.96 33.0558 10.3437 31.8463C10.0875 31.3436 9.87883 30.6229 9.76369 29.2136C9.6455 27.7669 9.643 25.8954 9.643 23.142V21.8563C9.643 19.1029 9.6455 17.2314 9.76369 15.7847C9.87883 14.3754 10.0875 13.6547 10.3437 13.152C10.96 11.9425 11.9434 10.959 13.153 10.3427C13.6557 10.0865 14.3764 9.87785 15.7857 9.76272C17.2324 9.64453 19.1039 9.64202 21.8573 9.64202Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3704_27539",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0714 33.75) rotate(-55.3758) scale(41.0136)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3704_27539",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4643 46.6071) rotate(-65.1363) scale(36.3121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3704_27539",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2.41071 1.60714) rotate(-8.1301) scale(62.5032 13.3688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3182df75ba5002bcec2e9c01c9e72144.svg";
export { ForwardRef as ReactComponent };